import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SEO } from "@/components/SEO";
import { GUIDES } from "@/data/guidesData";
import { buildItemListSchema } from "@/data/advancedSchemas";
import { getIcon } from "@/components/content/iconResolver";

export default function GuidesIndexPage() {
  const schema = buildItemListSchema(GUIDES, "/guides", "Guides réparation Mediastore Niort");
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Guides", path: "/guides" },
  ];

  return (
    <div className="min-h-screen" data-testid="guides-index-page">
      <SEO
        title="30 Guides Réparation iPhone, Mac, PC — Mediastore Niort"
        description="30 guides experts pour réparer iPhone, Mac, PC, console, et plus. Tutoriels pas-à-pas par les techniciens Apple certifiés Mediastore Niort."
        keywords="guides réparation, comment réparer iPhone, comment réparer Mac, Mediastore Niort, tutoriel réparation"
        path="/guides"
        schema={schema}
        breadcrumbs={breadcrumbs}
      />

      <section className="bg-gradient-to-br from-red-50 to-white pt-12 pb-8">
        <div className="container-custom max-w-4xl text-center">
          <Badge className="bg-red-100 text-red-700 px-3 py-1 mb-4 hover:bg-red-100">
            30 guides experts
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Guides réparation iPhone, Mac, PC, Console
          </h1>
          <p className="text-lg text-slate-700">
            30 tutoriels pas-à-pas rédigés par les techniciens Apple certifiés Mediastore Niort.
            Diagnostic gratuit en boutique au 104 Rue de la Gare 79000 Niort.
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-5xl">
          <div className="grid md:grid-cols-2 gap-4">
            {GUIDES.map((g) => {
              const Icon = getIcon(g.icon);
              return (
                <Link key={g.slug} to={`/guides/${g.slug}`} className="block group" data-testid={`guide-link-${g.slug}`}>
                  <Card className="h-full hover:shadow-md transition-shadow border-slate-200 group-hover:border-red-300">
                    <CardContent className="p-5">
                      <div className="flex gap-3 mb-3">
                        <div className="flex-shrink-0 p-2 bg-red-50 rounded-lg text-red-600">
                          <Icon className="h-5 w-5" />
                        </div>
                        <Badge className="bg-slate-100 text-slate-600 text-xs ml-auto hover:bg-slate-100">
                          {g.category}
                        </Badge>
                      </div>
                      <h3 className="font-semibold text-slate-900 group-hover:text-red-600 transition-colors mb-2">
                        {g.title}
                      </h3>
                      <p className="text-sm text-slate-500 line-clamp-2">
                        {g.metaDescription}
                      </p>
                    </CardContent>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
